import Button from '@/common/components/Button'
import { CurrencyTextField } from '@/common/components/CurrencyTextField'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import Modal from '@/common/components/Modal'
import { UnitTextField } from '@/common/components/UnitTextField'
import { formatCurrency, formatDecimalUnit } from '@/common/utils/formatters'
import { ProductCategoryDistributionItem } from '@/features/governmentAllocations/components/GovernmentAllocationDistribution/ProductCategoryDistributionItem'
import { CompanyGovernmentAllocationDistribution } from '@/features/governmentAllocations/types/governmentAllocationDistribution.type'
import { BriefcaseBusinessIcon } from 'lucide-react'
import { Dispatch, SetStateAction } from 'react'

interface GovernmentAllocationDistributionShowModalProps {
  distribution: CompanyGovernmentAllocationDistribution
  setDistribution: Dispatch<SetStateAction<CompanyGovernmentAllocationDistribution | undefined>>
  isConsumptionControlledByQuantity?: boolean
}

export const GovernmentAllocationDistributionShowModal = ({
  distribution,
  setDistribution,
  isConsumptionControlledByQuantity
}: GovernmentAllocationDistributionShowModalProps) => {
  return (
    <Modal
      isOpen={!!distribution}
      title="Detalhes da distribuição"
      showClose={false}
      className="min-w-[640px] overflow-hidden"
      body={
        <div className="flex flex-col gap-6 text-white-800">
          <ImageWithDisplayName
            placeholderIcon={BriefcaseBusinessIcon}
            imageUrl={distribution?.branch?.general_information?.company_logo?.url}
            displayName={distribution?.branch?.display_name}
            imageClassName="size-8"
            iconClassName="size-6"
          />

          <div className="max-h-[480px] min-h-[320px] overflow-auto flex flex-col gap-6 pe-2">
            {isConsumptionControlledByQuantity ? (
              <UnitTextField
                label="Quantidade limite"
                decimals={2}
                value={formatDecimalUnit(Number(distribution.total_quantity))}
                disabled
              />
            ) : (
              <CurrencyTextField
                label="Valor limite"
                value={formatCurrency(Number(distribution.total_value) || 0)}
                disabled
              />
            )}

            {distribution?.product_categories_distributions?.map((productCategoryDistribution) => (
              <ProductCategoryDistributionItem
                key={productCategoryDistribution?.id}
                productCategoryDistribution={productCategoryDistribution}
                isConsumptionControlledByQuantity={isConsumptionControlledByQuantity}
              />
            ))}
          </div>

          <Button onClick={() => setDistribution(undefined)}>Fechar</Button>
        </div>
      }
    />
  )
}
